.confirmationFooter {
  border-top: none;
}

.confirmationHeader {
  h2 {
    font-size: 2.4rem;
  }
}
